import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { api } from "../../lib/api";

const PURPLE = "#5B2CA0";

export default function CreditTabs({ markSeen = false }) {
  const loc = useLocation();
  const [unseen, setUnseen] = useState(0);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        if (markSeen) {
          await api.post("/credit/performance/availability/seen");
          if (active) setUnseen(0);
          return;
        }
        const { data } = await api.get("/credit/performance/availability/unseen");
        if (active) setUnseen(data.count || 0);
      } catch { /* ignore */ }
    })();
    return () => { active = false; };
  }, [markSeen]);

  const tabs = [
    { to: "/admin/credito", label: "Dashboard", tid: "Dashboard" },
    { to: "/admin/credito/performance", label: "Performance & Gate", tid: "Performance", badge: !markSeen && unseen > 0 },
    { to: "/admin/credito/alertas", label: "Alertas de Crédito", tid: "Alertas" },
  ];

  return (
    <div className="mb-4 flex flex-wrap gap-2" data-testid="credit-tabs">
      {tabs.map((t) => (
        <Link key={t.to} to={t.to} data-testid={`credit-tab-${t.tid}`}
          className={`relative rounded-full px-4 py-1.5 text-[13px] font-bold ${loc.pathname === t.to ? "text-white" : "text-[#5C5A57] border border-[#D6CFC7]"}`}
          style={loc.pathname === t.to ? { background: PURPLE } : {}}>
          {t.label}
          {t.badge && (
            <span className="ml-2 rounded-full bg-[#2E7D46] px-1.5 py-0.5 text-[9px] font-bold text-white" data-testid="perf-new-badge">Novo</span>
          )}
        </Link>
      ))}
    </div>
  );
}
